import { isEmbarcacaoVazaoBombasEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoVazaoBombas,
  EmbarcacaoVazaoBombasState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const VAZAO_BOMBAS_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoVazaoBombas> = {
  select: (ficha) => ficha.vazaoBombas,
  isEmpty: isEmbarcacaoVazaoBombasEmpty,
  secao: "a Vazão das Bombas",
};

interface UseEmbarcacaoVazaoBombasResult extends EmbarcacaoVazaoBombasState {
  reload: () => void;
}

/**
 * Consulta a Vazão das Bombas da embarcação pedida (AC4). Somente leitura:
 * nenhuma escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoVazaoBombas(id: string): UseEmbarcacaoVazaoBombasResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, VAZAO_BOMBAS_QUERY);

  return { ...state, vazaoBombas: data };
}
